import type { AuthenticatorProps } from '@aws-amplify/ui-react';
import { SOCIAL_LOGIN_ENABLED } from '@/config/cognito';
import i18n from '@/i18n/i18n';

/** Sign-up tab on the auth gate — open for self-registration; invitations still enable sign-up on `/accept-invitation`. */
export const AUTH_SIGN_UP_ENABLED = true;

export { SOCIAL_LOGIN_ENABLED };

/** Amplify Authenticator social provider buttons (order matches ticket 126). */
export const authSocialProviders: NonNullable<AuthenticatorProps['socialProviders']> = SOCIAL_LOGIN_ENABLED
  ? ['google', 'apple']
  : [];

export { authComponents } from '@/components/auth/authComponents';

/**
 * Cognito sign-up fields — nickname avoids mobile autofill treating it as phone.
 * Getters resolve through i18next; parent must re-render on language change (see App.tsx).
 */
export const authFormFields: AuthenticatorProps['formFields'] = {
  signUp: {
    nickname: {
      autocomplete: 'nickname',
      get label() {
        return i18n.t('auth:form.displayName');
      },
      get placeholder() {
        return i18n.t('auth:form.displayNamePlaceholder');
      },
      order: 3
    }
  }
};
